import { useEffect } from "react";
import { toast } from "sonner";

export const useOAuthCallback = () => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    // Handle OAuth success
    if (urlParams.has("callback") || urlParams.has("success")) {
      // Clear the URL parameters after handling the success state
      const newUrl = window.location.pathname;
      window.history.replaceState({}, "", newUrl);
    }

    // Handle OAuth errors
    if (urlParams.has("error")) {
      const errorDescription =
        urlParams.get("error_description") || "Unknown error occurred";

      toast.error(`Calendar connection failed: ${errorDescription}`);

      // Clear the URL parameters
      const newUrl = window.location.pathname;
      window.history.replaceState({}, "", newUrl);
    }
  }, []);

  // Helper to check if we're returning from callback
  const isReturningFromCallback = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has("callback") || urlParams.has("success");
  };

  return {
    isReturningFromCallback: isReturningFromCallback(),
  };
};
